import on_response from "./axiosConfig/onResponse"
import on_request from "./axiosConfig/onRequest"
import on_response_error from "./axiosConfig/onResponseError"
import on_request_error from "./axiosConfig/onRequestError"

/**
 * Configurates axios module.
 *
 * @param {object} context - Nuxt context.
 * @param {object} context.$axios - The axios module object.
 * @param {object} context.app - Equivalence of the in Vue app this member.
 */
export default function ({ $axios, app }) {
  $axios.defaults.xsrfCookieName = "csrftoken"
  $axios.defaults.xsrfHeaderName = "X-CSRFToken"
  $axios.withCredentials = true
  $axios.onRequest(on_request.bind(app))
  $axios.onRequestError(on_request_error)
  $axios.onResponse(on_response.bind(app))
  $axios.onResponseError(on_response_error.bind(app))
}
